const OffersIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_22615_125852)">
        <path
          d="M8.39059 1.72367C8.1406 1.47361 7.80151 1.33308 7.44792 1.33301H2.66659C2.31296 1.33301 1.97382 1.47348 1.72378 1.72353C1.47373 1.97358 1.33325 2.31272 1.33325 2.66634V7.44767C1.33333 7.80127 1.47385 8.14035 1.72392 8.39034L7.52659 14.193C7.82959 14.4941 8.23942 14.6631 8.66659 14.6631C9.09375 14.6631 9.50358 14.4941 9.80659 14.193L14.1933 9.80634C14.4943 9.50333 14.6633 9.09351 14.6633 8.66634C14.6633 8.23917 14.4943 7.82935 14.1933 7.52634L8.39059 1.72367Z"
          stroke="#0A0A0A"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.00008 5.33366C5.18418 5.33366 5.33341 5.18442 5.33341 5.00033C5.33341 4.81623 5.18418 4.66699 5.00008 4.66699C4.81599 4.66699 4.66675 4.81623 4.66675 5.00033C4.66675 5.18442 4.81599 5.33366 5.00008 5.33366Z"
          fill="#0A0A0A"
          stroke="#0A0A0A"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_22615_125852">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default OffersIcon;
